import React, { useState } from "react";
import { toast } from "sonner";
import { Twitter, MessageCircle, Send, Share2, Facebook, Linkedin, Link as LinkIcon } from "lucide-react";

const targets = [
  {
    key: "twitter",
    label: "X / Twitter",
    icon: Twitter,
    href: (u, t) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(u)}&text=${encodeURIComponent(t)}`,
    color: "hover:bg-sky-500 hover:text-white hover:border-sky-500",
  },
  {
    key: "reddit",
    label: "Reddit",
    icon: Share2,
    href: (u, t) => `https://www.reddit.com/submit?url=${encodeURIComponent(u)}&title=${encodeURIComponent(t)}`,
    color: "hover:bg-orange-500 hover:text-white hover:border-orange-500",
  },
  {
    key: "whatsapp",
    label: "WhatsApp",
    icon: MessageCircle,
    href: (u, t) => `https://wa.me/?text=${encodeURIComponent(t + " " + u)}`,
    color: "hover:bg-emerald-500 hover:text-white hover:border-emerald-500",
  },
  {
    key: "telegram",
    label: "Telegram",
    icon: Send,
    href: (u, t) => `https://t.me/share/url?url=${encodeURIComponent(u)}&text=${encodeURIComponent(t)}`,
    color: "hover:bg-blue-500 hover:text-white hover:border-blue-500",
  },
  {
    key: "facebook",
    label: "Facebook",
    icon: Facebook,
    href: (u) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}`,
    color: "hover:bg-blue-600 hover:text-white hover:border-blue-600",
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    icon: Linkedin,
    href: (u) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(u)}`,
    color: "hover:bg-sky-700 hover:text-white hover:border-sky-700",
  },
];

export default function ShareBar({ shareUrl, title }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    toast.success("Share link copied");
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="share-bar">
      {targets.map((t) => (
        <a
          key={t.key}
          href={t.href(shareUrl, title || "Check out this image")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`share-${t.key}`}
          title={t.label}
          className={`h-10 w-10 rounded-full border border-border flex items-center justify-center text-muted-foreground transition-all duration-200 ${t.color}`}
        >
          <t.icon className="h-4.5 w-4.5" />
        </a>
      ))}
      <button
        onClick={copy}
        data-testid="share-copy-link"
        title="Copy link"
        className={`h-10 w-10 rounded-full border flex items-center justify-center transition-all duration-200 ${
          copied ? "bg-accent text-accent-foreground border-accent" : "border-border text-muted-foreground hover:bg-secondary"
        }`}
      >
        <LinkIcon className="h-4.5 w-4.5" />
      </button>
    </div>
  );
}
